export const MOCK_ZAR8_YIELD_TOTAL_VALUE = 25897.45;

export const MOCK_ZAR8_YIELD_TOTAL_LOCKED_VALUE = 29600;

export const MOCK_ZAR8_YIELD_LEDGER_ENTRIES = [
  {
    _id: "mock-ledger-6m",
    isMock: true,
    createdAt: "2025-10-12T00:00:00.000Z",
    valueInZar: 10000,
    productId: {
      _id: "mock-product-6m",
      name: "6 Month Yield",
      duration: {
        period: 6,
        unit: "month",
      },
      assetId: {
        asset: "zar8",
      },
      withdrawalFee: {
        feeType: "fixed",
        feeAmount: 0,
      },
    },
  },
  {
    _id: "mock-ledger-12m",
    isMock: true,
    createdAt: "2025-02-03T00:00:00.000Z",
    valueInZar: 12000,
    productId: {
      _id: "mock-product-12m",
      name: "12 Month Yield",
      duration: {
        period: 12,
        unit: "month",
      },
      assetId: {
        asset: "zar8",
      },
      withdrawalFee: {
        feeType: "fixed",
        feeAmount: 0,
      },
    },
  },
  {
    _id: "mock-ledger-5y",
    isMock: true,
    createdAt: "2025-01-19T00:00:00.000Z",
    valueInZar: 23290,
    productId: {
      _id: "mock-product-5y",
      name: "5 Year Yield",
      duration: {
        period: 5,
        unit: "year",
      },
      assetId: {
        asset: "zar8",
      },
      withdrawalFee: {
        feeType: "fixed",
        feeAmount: 0,
      },
    },
  },
];

export const MOCK_ZAR8_YIELD_PERFORMANCE_GRAPH = {
  performanceData: [
    { label: "2025-05-04", value: 650 },
    { label: "2025-05-05", value: 1020 },
    { label: "2025-05-06", value: 1625 },
    { label: "2025-05-07", value: 2250 },
    { label: "2025-05-08", value: 2100 },
    { label: "2025-05-09", value: 2180 },
    { label: "2025-05-10", value: 2280 },
    { label: "2025-05-11", value: 2920 },
  ],
};
